import * as React from 'react';
import { css } from '@emotion/core';
import { DevPlanCollaborator } from './models';
import CollaboratorListItem from './CollaboratorListItem';
import LocalDiv from '../../../localization/LocalDiv';
import { FLEX_ROW } from '../../../layout/flexBox';
import { COLORS } from '../../../globalStyle/colors';


const styles = {
  listItem: [
    FLEX_ROW,
    css`
      height: 72px;
      align-items: center;
      justify-content: stretch;
      border-bottom: 1px solid;
      border-image-slice: 1;
      border-image-source: linear-gradient(to right, transparent, ${COLORS.PROJECTBAR_GREY} 3% 97%, transparent);
    `,
  ],
};


type Props = {
  projectId: number;
  collaborators: DevPlanCollaborator[];
  deleteCollaborator: (email: string) => void;
  className?: string;
}


const renderItems = (
  projectId: number,
  collaborators: DevPlanCollaborator[],
  deleteCollaborator: (email: string) => void,
) => collaborators.map(c => (
    <CollaboratorListItem
      key={c.email}
      projectId={projectId}
      collaborator={c}
      deleteCollaborator={() => deleteCollaborator(c.email)}
      css={styles.listItem}
    />
  ),
);


/**
 * CollaboratorsList: a component that provides a list of all current dev plan collaborators and indicates whether they
 * have utilized their invitation to view the dev plan
 */
const CollaboratorsList: React.FC<Props> = ({ projectId, collaborators, deleteCollaborator, className }) => (
  <LocalDiv className={className}>
    {
      renderItems(projectId, collaborators, deleteCollaborator)
    }
  </LocalDiv>
);

export default CollaboratorsList;
